import { styled } from '@mui/material';

export const TabsW = styled('div')`
  width: calc(100% - 32px);
  border: ${({ theme }) => `1px solid ${theme.palette.primary.light}`};
  border-radius: 8px;
  padding: 4px 8px;
  font-weight: 400;
  font-size: 16px;
  line-height: 18px;
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  margin: 0 16px 16px;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const Tab = styled('div')`
  flex-shrink: 0;
  white-space: nowrap;
  text-align: center;
  padding: 8px 16px;
  cursor: pointer;
  color: ${({ theme }) => theme.palette.primary.main};
  &.active {
    color: ${({ theme }) => theme.palette.info.main};
  }
`;
